<script setup>
import PollDataTable from "@/components/dashboard/PollDataTable.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import { ref } from "vue";

const totalPolls = ref(0);
const showFilters = ref(false);

const updateTotalPolls = (count) => {
  totalPolls.value = count;
};

const toggleFilters = () => {
  showFilters.value = !showFilters.value;
};
</script>

<template>
  <div class="bg-gray-50 px-4 py-6 sm:px-6">
    <div class="max-w-7xl mx-auto">
      <div
        class="mb-8 flex flex-col gap-6 md:flex-row md:items-center md:justify-between"
      >
        <div>
          <h1 class="text-2xl font-semibold text-neutral-text mb-2">
            Polls Management
          </h1>
          <div class="flex items-center gap-2">
            <span class="text-neutral-light">Total Polls</span>
            <span
              class="bg-primary/10 text-primary-neutral text-sm font-medium px-2.5 py-0.5 rounded-full"
            >
              {{ totalPolls }}
            </span>
          </div>
        </div>
        <div
          class="flex w-full flex-row gap-2 sm:gap-3 sm:flex-row sm:flex-wrap md:w-auto md:justify-end"
        >
          <router-link
            class="block flex-1 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary sm:w-auto sm:flex-initial"
            to="/polls/create"
          >
            <ActionButton
              action="add"
              class="w-full py-2 text-xs sm:w-auto sm:py-2 sm:text-xs"
              variant="secondary"
              >Add Poll</ActionButton
            >
          </router-link>
          <ActionButton
            :active="showFilters"
            action="filter"
            class="flex-1 py-2 text-xs sm:w-auto sm:py-2 sm:text-xs"
            @click="toggleFilters"
          >
            Filter
          </ActionButton>
        </div>
      </div>
      <PollDataTable
        :show-filters="showFilters"
        @update-total="updateTotalPolls"
      />
    </div>
  </div>
</template>
